import React from 'react';
import { Grid } from '@mui/material';

const TabGridItem = ({ children, sx = {}, ...props }) => {
  return (
    <Grid
      item
      sx={{
        minWidth: { xs: `${100 / 6}%`, sm: `${100 / 8}%` },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Grid>
  );
};

export default TabGridItem;
